import React from 'react';
import {FormGroup, Input, Label} from 'reactstrap';
import './RejectStepSelect.scss';

const RejectStepSelect = ({value, onChange}) => {
  return (
    <FormGroup>
      <Label for="rejectStep" className="reject-step-label">Reject to</Label>
      <Input
        type="select"
        id="rejectStep"
        name="rejectStep"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <option value="author">Author</option>
        <option value="acknowledger">Acknowledger</option>
      </Input>
    </FormGroup>
  );
};

export default RejectStepSelect;